import type { BrowseAnalyticsMessages, Dictionary } from '../models'

import { LocaleEnum } from '../enums'

const DEFAULT_KPIS_MESSAGES_EN = {
  clicks: {
    valueLabel: 'clicks',
    percentageLabel: 'CTR',
    tooltip: 'Total number of clicks compared to the total number of views',
  },
  findability: {
    valueLabel: 'success clicks',
    percentageLabel: 'findability',
    tooltip:
      'Total number of clicks on the first page of the category compared to the total number of views',
  },
  add2cart: {
    valueLabel: 'add2carts',
    percentageLabel: 'Add2cart',
    tooltip:
      'Total number of add-to-cart actions on all pages for the category compared to the total number of views',
  },
  checkout: {
    valueLabel: 'checkouts',
    percentageLabel: 'Checkout',
    tooltip: 'Total number of checkout actions compared to the total number of views',
  },
  view: {
    valueLabel: 'views',
    tooltip: 'Total number of times the category page is displayed',
  },
  positionAvg: {
    valueLabel: 'avg. click position',
    tooltip: 'Average position where clicks are made for a product',
  },
}

const BROWSE_ANALYTICS_MESSAGES_EN: BrowseAnalyticsMessages = {
  kpis: Object.assign({}, DEFAULT_KPIS_MESSAGES_EN, {}),
  categoryLabel: 'Category',
  backToRoot: 'Back',
}

const DEFAULT_KPIS_MESSAGES_ES = {
  clicks: {
    valueLabel: 'clicks',
    percentageLabel: 'CTR',
    tooltip: 'Número total de clics comparado con el número total de visitas',
  },
  findability: {
    valueLabel: 'success clicks',
    percentageLabel: 'findability',
    tooltip:
      'Número total de clics realizados en la primera página de la categoría comparada con el número total de visitas',
  },
  add2cart: {
    valueLabel: 'add2carts',
    percentageLabel: 'Add2cart',
    tooltip:
      'Número total de acciones de añadir al carrito de la compra que se han hecho  comparadas con el número total de visitas',
  },
  checkout: {
    valueLabel: 'checkouts',
    percentageLabel: 'Checkout',
    tooltip: 'Número total de acciones de checkout comparadas con el número total de visitas',
  },
  view: {
    valueLabel: 'visitas',
    tooltip: 'Número total de veces que se muestra la página de categorías',
  },
  positionAvg: {
    valueLabel: 'posición media de clics',
    tooltip: 'Posición media donde se hace clic',
  },
}

const BROWSE_ANALYTICS_MESSAGES_ES: BrowseAnalyticsMessages = {
  kpis: Object.assign({}, DEFAULT_KPIS_MESSAGES_ES, {}),
  categoryLabel: 'Categoría',
  backToRoot: 'Volver',
}

export const BROWSE_ANALYTICS_MESSAGES: Dictionary<{ browseAnalytics: BrowseAnalyticsMessages }> = {
  [LocaleEnum.ENGLISH]: {
    browseAnalytics: BROWSE_ANALYTICS_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    browseAnalytics: BROWSE_ANALYTICS_MESSAGES_ES,
  },
}
